import React, { Component } from "react";

class NoMatch extends Component {
  render() {
    return <div className="home">No Match</div>;
  }
}
export default NoMatch;
